import { GameScene } from '@Core/GameScene/GameScene';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { IDynamicCasinoJackpotConfig, TJackpotCasinoLevelItem } from '@GFTypes/index';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { DynamicCasinoJackpotLevelsItem } from './DynamicCasinoJackpotLevelsItem';

export class DynamicCasinoJackpotLevels extends GameComponent {
    public scene: GameScene;
    private levels: {
        [key: number]: DynamicCasinoJackpotLevelsItem;
    } = {};

    constructor(scene: GameScene, config: IDynamicCasinoJackpotConfig) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'Dynamic Casino Jackpot Levels constructor'
        });

        this.init();
    }

    private init() {
        EventsCenter.on(EGameEvents.JACKPOT_CASINO_NOTIFICATION, this.levelsUpdate, this);
    }

    private createLevels(data: TJackpotCasinoLevelItem[]) {
        for (const level of data) {
            this.levels[level.levelOrder] = new DynamicCasinoJackpotLevelsItem(this.scene, level);
        }
    }

    private levelsUpdate() {
        const newLevelsStatus = this.gameStore.get(EGameStoreKeys.JackpotCasinoState).statusLevels;

        if (Object.keys(this.levels).length === 0) {
            this.createLevels(newLevelsStatus);
        } else {
            for (const level of newLevelsStatus) {
                this.levels[level.levelOrder].update(level);
            }
        }
    }
}
